import React, { useEffect, useState } from "react";
import { ShimmerPostDetails } from "react-shimmer-effects";

import PageFooter from "@/components/common/PageFooter";
import PopupSignInUp from "@/components/common/PopupSignInUp";
import Header from "@/components/common/header/DefaultHeader";
import MobileMenu from "@/components/common/header/MobileMenu";
import SellFaqSection from "@/components/sell/FAQ/SellFaqSection";
import SellHeroSection from "@/components/sell/Hero/SellHeroSection";
import SellRegisterToday from "@/components/sell/RegisterTodaySection/SellRegisterToday";
import SellStatsSection from "@/components/sell/SellStatsSection/SellStatsSection";
import SellProgramSection from "@/components/sell/SellProgramSection/SellProgramSection";
import SellHowItWorks from "@/components/sell/HowItWorksSection/SellHowItWorks";
import MetaComponent from "@/components/common/MetaComponent";
import { getSupportData } from "@/api/faq";
import { generateSellResidentialSchema, injectSchema, removeSchema } from "@/utils/schema";

const metadata = {
  title: "Sell Your Property at Auction | Hubzu's Signature Home Auctions",
};

const SellPageResidential = () => {
  const [sellCMSData, setSellSMSData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getCMSData = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await getSupportData("sellResidential");
        setSellSMSData(data?.results || []);
      } catch (err) {
        setError("Unable to load content. Please try again later.");
        console.error("Error fetching data: ", err);
      } finally {
        setLoading(false);
      }
    };
    getCMSData();
  }, []);

  useEffect(() => {
    const schemas = generateSellResidentialSchema();
    schemas.forEach((schema, index) => {
      injectSchema(schema, `sell-residential-schema-${index}`);
    });
    return () => {
      schemas.forEach((_, index) => {
        removeSchema(`sell-residential-schema-${index}`);
      });
    };
  }, []);

  const renderContent = () => {
    if (loading) {
      return (
        <div className="loading-section">
          <ShimmerPostDetails card cta variant="EDITOR" />
        </div>
      );
    }

    if (error || !Array.isArray(sellCMSData) || sellCMSData.length === 0) {
      return (
        <div className="d-flex align-items-center justify-content-center vh-100">
          <div className="text-center">
            <div className="alert alert-danger" role="alert">
              <h2 className="alert-heading">Unable to Load Content</h2>
              <p>
                {error ||
                  "Sorry, something went wrong while fetching the data. Please try again later."}
              </p>
              <hr />
              <button
                className="btn btn-thm btn-primary"
                onClick={() => window.location.reload()}
              >
                Retry
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <>
        <SellHeroSection cmsData={sellCMSData} type="residential" />
        <SellHowItWorks cmsData={sellCMSData} type="residential" />
        <SellProgramSection cmsData={sellCMSData} type="residential" />
        <SellRegisterToday cmsData={sellCMSData} type="residential" />
        <SellStatsSection cmsData={sellCMSData} type="residential" />
        <SellFaqSection cmsData={sellCMSData} type="residential" />
      </>
    );
  };

  return (
    <>
      <MetaComponent meta={metadata} />
      <div className="d-flex flex-column min-vh-100">
        <Header />
        <MobileMenu />
        <PopupSignInUp />

        <div
          style={{ flex: 1, marginTop: "calc(3.5rem + 1.75vw)" }}
          className="flex-grow-1"
        >
          {renderContent()}
        </div>

        <PageFooter />
      </div>
    </>
  );
};

export default SellPageResidential;
